import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'EditPopupModal',
  props: {
    params: Object
  },
  data: function data() {
    return {
      row: null,
      column: null,
      modalVisible: false,
      loading: false,
      tableData: [],
      tableColumn: [{
        type: 'checkbox',
        width: 80
      }, {
        field: 'name',
        title: 'Name'
      }, {
        field: 'role',
        title: 'Role'
      }, {
        field: 'sex',
        title: 'Sex'
      }],
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      }
    };
  },
  created: function created() {
    this.load();
  },
  methods: {
    load: function load() {
      var _this = this;

      var _this$params = this.params,
          row = _this$params.row,
          column = _this$params.column;
      this.row = row;
      this.column = column;
      this.getData().then(function (data) {
        _this.tableData = data;
      });
    },
    getData: function getData() {
      return new Promise(function (resolve) {
        setTimeout(function () {
          var list = [{
            name: 'Test1',
            role: '前端',
            sex: '男'
          }, {
            name: 'Test2',
            role: '后端',
            sex: '男'
          }, {
            name: 'Test3',
            role: '测试',
            sex: '男'
          }, {
            name: 'Test4',
            role: '设计师',
            sex: '女'
          }, {
            name: 'Test5',
            role: '前端',
            sex: '男'
          }, {
            name: 'Test6',
            role: '前端',
            sex: '男'
          }, {
            name: 'Test7',
            role: '前端',
            sex: '男'
          }];
          resolve(list);
        }, 100);
      });
    },
    popupEvent: function popupEvent() {
      this.modalVisible = true;
    },
    pageChangeEvent: function pageChangeEvent(_ref) {
      var _this2 = this;

      var currentPage = _ref.currentPage,
          pageSize = _ref.pageSize;
      this.tablePage.currentPage = currentPage;
      this.tablePage.pageSize = pageSize;
      this.loading = true;
      this.getData().then(function (data) {
        _this2.loading = false;
        _this2.tableData = data;
      });
    },
    confirmEvent: function confirmEvent() {
      var row = this.row,
          column = this.column;
      var selectRecords = this.$refs.xGrid.getCheckboxRecords();
      row[column.property] = "".concat(selectRecords.length, "\u6761");
    }
  }
};